import React from 'react';
import { Overlay, Spinner } from '@blueprintjs/core';
import styles from './LoadingOverlay.module.sass';

const LoadingOverlay = ({ isOpen = false, message = 'Loading...' }) => {
  return (
    <Overlay
      isOpen={isOpen}
      hasBackdrop={true}
      canEscapeKeyClose={false}
      canOutsideClickClose={false}
      usePortal={true}
      enforceFocus={false}
      backdropProps={{ className: styles.backdrop }}
    >
      <div className={styles.container}>
        <Spinner size={60}/>
        <div className={styles.message}>{message}</div>
      </div>
    </Overlay>
  );
};

export default LoadingOverlay;
